import React from "react";
import ReactWOW from 'react-wow';
import { $t } from '@/modules/i18n';

class Training extends React.Component {
  render() {
    const msg = this.props.Message;
    const desc = Array.isArray(msg.trainingDesc) ? $t(msg.trainingDesc) : [$t(msg.trainingDesc)];

    return (
      <section id="training">
        <div className="container">
          <div className="title-block">
            <h2>{$t(msg.trainingWorkshops)}</h2>
            {
              desc.map(item => <p key={item}>{$t(item)}</p>)
            }
          </div>
          <div className="flex-box">
            {
              msg.trainingData.map((item, index) => {
                return (
                  <ReactWOW animation="fadeInUp" delay="0.1s" key={index}>
                    <div className="box box-2">
                      {item.date ? <small>{$t(item.date)}</small> : null}
                      <h4><img className="square" src={require("@ndsc/assets/images/icon-square.png")} style={{ width: "40px", marginRight: "12px" }} alt="" />{$t(item.name)}
                        <p className="tag">
                        {$t(msg.by)} {$t(item.organizer)}
                        {item.location ? " (" + $t(item.location) + ")" : null}
                        {item.registerLink ? <a href={item.registerLink} target="_blank" rel="noopener noreferrer" className="btn-link"> {$t(msg.register)}</a> : null}
                        </p></h4>
                      {item.state ? <p>{$t(item.state)}</p> : null}
                      <ul>
                        {
                          item.list.map((i, index) => {
                            return (
                              <li key={index} dangerouslySetInnerHTML={{ __html: $t(i) }}></li>
                            )
                          })
                        }
                      </ul>
                      
                    </div>
                  </ReactWOW>
                );
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default Training;